import { getProjects } from 'containers/Projects/actions';

export const pollLoadingProjects = (dispatch) => {
  const payload = {
    page: 0,
    pageSize: 100,
    isArchived: false,
    leadId: 0,
    key: '',
  };
  const timer = setInterval(() => dispatch(getProjects(payload)), 5000);
  return timer;
};
